function extractEventId(pathname: string): string | undefined {
  const segments = pathname.split('/').filter(Boolean)

  if (
    (segments[0] === 'event' || segments[0] === 'events') &&
    typeof segments[1] === 'string'
  ) {
    return segments[1]
  }

  return undefined
}
export default { extractEventId }
